import * as React from "react";

import { useTabSlotRegistry } from "./context";

/**
 * A named landing place for a tab's portal host.
 *
 * `display: contents` is the whole trick: the slot must occupy no box of its own, or every tab
 * would gain an extra layout wrapper and the strip's flex layout would measure the wrapper
 * instead of the tab. It exists purely so the list has somewhere to `appendChild` the host.
 */
export function TabSlot({
  slotId,
  value,
  ...rest
}: { slotId: string; value: string } & React.HTMLAttributes<HTMLDivElement>) {
  const registry = useTabSlotRegistry();
  const handleRef = React.useCallback(
    (element: HTMLDivElement | null) => registry?.registerSlot(slotId, element),
    [registry, slotId],
  );
  return (
    <div
      data-slotid={slotId}
      data-tabslot=""
      data-value={value}
      ref={handleRef}
      role="presentation"
      style={{ display: "contents" }}
      {...rest}
    />
  );
}
